import React from 'react';
import Banner from './Banner';
import styles from './FixedBottomBanner.module.scss';

const FixedBottomBanner = (props: React.ComponentProps<typeof Banner>) => (
  <div className={styles.wrapper}>
    <Banner {...props} />
  </div>
);

export default FixedBottomBanner;
